<template>
    <div id="price">
        <div class="inline price-header">
            <span>1ч</span>
            <span>12ч</span>
            <span>24ч</span>
        </div>
        <div class="inline" valign="center">
            <div class="checkbox">
                <input type="checkbox" id="auto" v-model="data[0].active" />
                <label for="auto">Авто</label>
            </div>
            <input type="text" class="text-input" v-model="data[0].price_1" />
            <input type="text" class="text-input" v-model="data[0].price_2" />
            <input type="text" class="text-input" v-model="data[0].price_3" />
        </div>
        <div class="inline" valign="center">
            <div class="checkbox">
                <input type="checkbox" id="jeep" v-model="data[1].active" />
                <label for="jeep">Джип</label>
            </div>
            <input type="text" class="text-input" v-model="data[1].price_1" />
            <input type="text" class="text-input" v-model="data[1].price_2" />
            <input type="text" class="text-input" v-model="data[1].price_3" />
        </div>
        <div class="inline" valign="center">
            <div class="checkbox">
                <input type="checkbox" id="moto" v-model="data[2].active" />
                <label for="moto">Мото</label>
            </div>
            <input type="text" class="text-input" v-model="data[2].price_1" />
            <input type="text" class="text-input" v-model="data[2].price_2" />
            <input type="text" class="text-input" v-model="data[2].price_3" />
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data']
    }
</script>